const translations = {
  en: {
    leaveManagement: "Leave Management",
    reviewAndApprove: "Review and approve employee leave requests",
    errorLoadingRequests: "Error Loading Requests",
    pendingRequests: "Pending Requests",
    approved: "Approved",
    rejected: "Rejected",
    totalRequests: "Total Requests",
    pending: "Pending",
    searchAndFilter: "Search & Filter",
    findAndFilter: "Find and filter leave requests",
    showing: "Showing",
    of: "of",
    requests: "requests",
    searchEmployee: "Search Employee",
    searchPlaceholder: "Search employee or reason...",
    leaveType: "Leave Type",
    allTypes: "All Types",
    annual: "Annual",
    sick: "Sick",
    maternity: "Maternity",
    emergency: "Emergency",
    wfh: "Work From Home",
    partialDay: "Partial Day Request",
    actions: "Actions",
    refresh: "Refresh",
    loading: "Loading...",
    leaveRequests: "Leave Requests",
    loadingRequests: "Loading requests...",
    noRequestsFound: "No leave requests found",
    tryAdjusting: "Try adjusting your filters or search criteria",
    leaveRequestReview: "Leave Request Review",
    employeeInformation: "Employee Information",
    requestedOn: "Requested on",
    requestDetails: "Request Details",
    startDate: "Start Date",
    endDate: "End Date",
    duration: "Duration",
    days: "days",
    status: "Status",
    reasonForLeave: "Reason for Leave",
    prescription: "Medical Prescription",
    viewPrescription: "View Prescription",
    openingPrescription: "Opening...",
    prescriptionMissing: "No prescription attached to this request",
    prescriptionLoadFailed: "Could not open the prescription",
    yourDecision: "Your Decision",
    approve: "Approve",
    reject: "Reject",
    approvalComments: "Approval Comments",
    reasonForRejection: "Reason for Rejection",
    optional: "(Optional)",
    approvalCommentsPlaceholder: "Add any notes about this approval...",
    rejectionReasonPlaceholder: "Please explain why this request is being rejected...",
    cancel: "Cancel",
    processing: "Processing...",
    submitApproval: "Submit Approval",
    submitRejection: "Submit Rejection",
    submitDecision: "Submit Decision",
    unknownEmployee: "Unknown Employee",
    leave: "Leave",
    all: "All",
    manageEmployeeLeaves: "Manage Employee Leaves",
    manageEmployeeLeavesDesc: "Select an employee to view and manage their manual leaves",
    selectEmployee: "Select Employee",
    searchEmployeePlaceholder: "Search by name or code...",
    noEmployeesFound: "No employees found",
    employeeLeaves: "Employee Leaves",
    noLeavesFound: "No manual leaves found for this employee",
    addNewLeave: "Add New Leave",
    createLeave: "Create Leave",
    skipNotificationLabel: "Skip confirmation notification",
    creating: "Creating...",
    deleting: "Deleting...",
    confirmDelete: "Delete this leave?",
    back: "Back",
    manualLeaves: "Manual Leaves",
    leaveCreatedSuccess: "Leave created successfully",
    leaveDeletedSuccess: "Leave deleted successfully",
    selectLeaveType: "Select leave type",
    custom: "Custom",
    customTypePlaceholder: "Enter leave type name...",
    halfDayType: "Half-Day Type",
    firstHalf: "First Half (Morning)",
    secondHalf: "Second Half (Afternoon)",
    selectHalfDayType: "Select half-day type",
    balanceRemaining: "Remaining Balance",
    balanceDays: "days remaining",
    insufficientBalance: "Insufficient Balance",
    insufficientBalanceMsg: "Employee does not have enough balance. Remaining",
    cannotDeletePastLeave: "Cannot Delete",
    cannotDeletePastLeaveMsg: "Leaves cannot be deleted more than 2 days after the start date has passed.",
    quotaLabel: "/ total",
    holidayManagement: "Holiday Management",
    holidayManagementDesc: "Manage official holidays per client and company",
    holidayName: "Holiday Name",
    holidayDate: "Holiday Date",
    clientNameLabel: "Client Name",
    workingCompanyLabel: "Working Company",
    createHoliday: "Create Holiday",
    saveChanges: "Save Changes",
    editHoliday: "Edit Holiday",
    deleteHoliday: "Delete Holiday",
    confirmDeleteHoliday: "Are you sure you want to delete this holiday?",
    holidayCreated: "Holiday created successfully",
    holidayUpdated: "Holiday updated successfully",
    holidayDeleted: "Holiday deleted successfully",
    noHolidaysFound: "No holidays found",
    filterByClient: "Filter by Client",
    filterByCompany: "Filter by Company",
    allClients: "All Clients",
    allCompanies: "All Companies",
    holidayNamePlaceholder: "e.g. Eid Al-Fitr",
    selectClient: "Select Client",
    selectCompany: "Select Company",
    selectWorkingCompany: "Select Working Company",
    selectCompanyForHoliday: "Choose a company to create/edit holiday",
    chooseCompanyFromList: "Choose a company from the list below",
    loadingCompanies: "Loading companies...",
    noCompaniesFound: "No companies found",
    date: "Date",
  },
  ar: {
    leaveManagement: "إدارة الإجازات",
    reviewAndApprove: "مراجعة والموافقة على طلبات إجازات الموظفين",
    errorLoadingRequests: "خطأ في تحميل الطلبات",
    pendingRequests: "الطلبات المعلقة",
    approved: "موافق عليها",
    rejected: "مرفوضة",
    totalRequests: "إجمالي الطلبات",
    pending: "معلق",
    searchAndFilter: "البحث والفلترة",
    findAndFilter: "ابحث وفلتر طلبات الإجازات",
    showing: "عرض",
    of: "من",
    requests: "طلب",
    searchEmployee: "البحث عن موظف",
    searchPlaceholder: "ابحث عن موظف أو سبب...",
    leaveType: "نوع الإجازة",
    allTypes: "جميع الأنواع",
    annual: "سنوية",
    sick: "مرضية",
    maternity: "أمومة",
    emergency: "طارئة",
    wfh: "العمل من المنزل",
    partialDay: "طلب يوم جزئي",
    actions: "الإجراءات",
    refresh: "تحديث",
    loading: "جاري التحميل...",
    leaveRequests: "طلبات الإجازات",
    loadingRequests: "جاري تحميل الطلبات...",
    noRequestsFound: "لم يتم العثور على طلبات إجازة",
    tryAdjusting: "حاول تعديل الفلاتر أو معايير البحث",
    leaveRequestReview: "مراجعة طلب الإجازة",
    employeeInformation: "معلومات الموظف",
    requestedOn: "تم الطلب في",
    requestDetails: "تفاصيل الطلب",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    duration: "المدة",
    days: "أيام",
    status: "الحالة",
    reasonForLeave: "سبب الإجازة",
    prescription: "الروشتة الطبية",
    viewPrescription: "عرض الروشتة",
    openingPrescription: "جاري الفتح...",
    prescriptionMissing: "لا توجد روشتة مرفقة بهذا الطلب",
    prescriptionLoadFailed: "تعذر فتح الروشتة",
    yourDecision: "قرارك",
    approve: "موافقة",
    reject: "رفض",
    approvalComments: "تعليقات الموافقة",
    reasonForRejection: "سبب الرفض",
    optional: "(اختياري)",
    approvalCommentsPlaceholder: "أضف أي ملاحظات حول هذه الموافقة...",
    rejectionReasonPlaceholder: "يرجى شرح سبب رفض هذا الطلب...",
    cancel: "إلغاء",
    processing: "جاري المعالجة...",
    submitApproval: "إرسال الموافقة",
    submitRejection: "إرسال الرفض",
    submitDecision: "إرسال القرار",
    unknownEmployee: "موظف غير معروف",
    leave: "إجازة",
    all: "الكل",
    manageEmployeeLeaves: "إدارة إجازات الموظفين",
    manageEmployeeLeavesDesc: "اختر موظفاً لعرض وإدارة إجازاته اليدوية",
    selectEmployee: "اختر موظفاً",
    searchEmployeePlaceholder: "ابحث بالاسم أو الكود...",
    noEmployeesFound: "لا يوجد موظفون",
    employeeLeaves: "إجازات الموظف",
    noLeavesFound: "لا توجد إجازات يدوية لهذا الموظف",
    addNewLeave: "إضافة إجازة جديدة",
    createLeave: "إنشاء إجازة",
    skipNotificationLabel: "تخطي إشعار التأكيد",
    creating: "جاري الإنشاء...",
    deleting: "جاري الحذف...",
    confirmDelete: "حذف هذه الإجازة؟",
    back: "رجوع",
    manualLeaves: "الإجازات اليدوية",
    leaveCreatedSuccess: "تم إنشاء الإجازة بنجاح",
    leaveDeletedSuccess: "تم حذف الإجازة بنجاح",
    selectLeaveType: "اختر نوع الإجازة",
    custom: "مخصص",
    customTypePlaceholder: "أدخل اسم نوع الإجازة...",
    halfDayType: "نوع نصف اليوم",
    firstHalf: "النصف الأول (صباحي)",
    secondHalf: "النصف الثاني (عصري)",
    selectHalfDayType: "اختر نوع نصف اليوم",
    balanceRemaining: "الرصيد المتبقي",
    balanceDays: "يوم متبقي",
    insufficientBalance: "رصيد غير كافٍ",
    insufficientBalanceMsg: "ليس لدى الموظف رصيد كافٍ. المتبقي",
    cannotDeletePastLeave: "لا يمكن الحذف",
    cannotDeletePastLeaveMsg: "لا يمكن حذف الإجازات بعد مرور أكثر من يومين من تاريخ البداية.",
    quotaLabel: "/ الإجمالي",
    holidayManagement: "إدارة الإجازات الرسمية",
    holidayManagementDesc: "إدارة الإجازات الرسمية لكل عميل وشركة",
    holidayName: "اسم الإجازة",
    holidayDate: "تاريخ الإجازة",
    clientNameLabel: "اسم العميل",
    workingCompanyLabel: "الشركة",
    createHoliday: "إنشاء إجازة",
    saveChanges: "حفظ التغييرات",
    editHoliday: "تعديل الإجازة",
    deleteHoliday: "حذف الإجازة",
    confirmDeleteHoliday: "هل أنت متأكد من حذف هذه الإجازة؟",
    holidayCreated: "تم إنشاء الإجازة بنجاح",
    holidayUpdated: "تم تحديث الإجازة بنجاح",
    holidayDeleted: "تم حذف الإجازة بنجاح",
    noHolidaysFound: "لا توجد إجازات رسمية",
    filterByClient: "فلتر بالعميل",
    filterByCompany: "فلتر بالشركة",
    allClients: "جميع العملاء",
    allCompanies: "جميع الشركات",
    holidayNamePlaceholder: "مثال: عيد الفطر",
    selectClient: "اختر العميل",
    selectCompany: "اختر الشركة",
    selectWorkingCompany: "اختر الشركة العاملة",
    selectCompanyForHoliday: "اختر شركة لإنشاء/تعديل الإجازة",
    chooseCompanyFromList: "اختر شركة من القائمة أدناه",
    loadingCompanies: "جاري تحميل الشركات...",
    noCompaniesFound: "لم يتم العثور على شركات",
    date: "التاريخ",
  }
};

export default translations;